import './App.css';
import { Routes, Route, HashRouter } from 'react-router-dom';
import Detail from './routes/detail';
import { useEffect } from 'react';
import { createPhoenixMessageListener, notifyPhoenixWindowReady, useGetAuthenticateQuery } from './api/phoenix';
import { RootState, useAppDispatch } from '.';
import { useSelector } from 'react-redux';
import React from 'react';

function App() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const listener = createPhoenixMessageListener(dispatch);
    window.addEventListener('message', listener);
    notifyPhoenixWindowReady();
    return () => {
      window.removeEventListener('message', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasToken = useSelector<RootState, boolean>(state => !!state.auth.token);
  const { error, isLoading } = useGetAuthenticateQuery(0, {
    skip: !hasToken,
  });

  if (!hasToken || isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Fehler bei der Anmeldung: {JSON.stringify(error)}</div>;
  }

  return (
    <HashRouter>
      <Routes>
        <Route path="detail/:id" element={<Detail />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
